export default __webpack_public_path__ + "static/media/i-hand.4b307483.svg";